module.exports = __webpack_public_path__ + "img/coming-soon-dark.171cc329.svg";